import Konva from 'konva';
import _ from 'lodash';
import Area from './Area';
import { uuid2 as uuid } from '@/utils';

class Point {
  constructor(id, x, y) {
    this.uuid = id || uuid();
    this.id = this.uuid;
    this.x = x;
    this.y = y;
  }
}
const STATE = {
  VIEW: 'view',
  ADD: 'add',
  EDIT: 'edit',
};
export default class Stage {
  constructor(option) {
    this.option = option;
    const { container } = this.option;
    const { clientWidth, clientHeight } = container;

    this.stage = new Konva.Stage({
      container,
      width: clientWidth,
      height: clientHeight,
      draggable: true,
    });

    this.bgLayer = new Konva.Layer();
    this.areaLayer = new Konva.Layer();
    this.editLayer = new Konva.Layer();
    this.viewLayer = new Konva.Layer();

    this.stage.add(this.bgLayer);
    this.stage.add(this.areaLayer);
    this.stage.add(this.editLayer);
    this.stage.add(this.viewLayer);

    this.bgLayer.draw();
    this.areaLayer.draw();
    this.editLayer.draw();

    // 当前编辑状态
    this.state = 'view';
    // 背景图
    this.background = null;

    // 当前的点
    this.prevPoint = null;
    this.prevLine = null;
    this.curPoints = null;
    this.curShape = null;
    this.snapLine = null;
    // 坐标点集合
    this.pointDict = {};
    // 图形集合
    this.graphicList = [];

    // 编辑点位几个
    this.pointList = [];

    // 键盘对应
    this.key = '';

    // 缩放和位移相关
    this.graphicPosition = { x: 0, y: 0 };
    this.graphicScale = 1;


    this.tr = new Konva.Transformer({
      resizeEnabled: false,
      rotateEnabled: false,
    });
    this.areaLayer.add(this.tr);

    // 鼠标点，跟随鼠标移动
    this.mousePoint = new Konva.Circle({
      id: -1,
      radius: 5,
      fill: 'blue',
    });
    this.areaLayer.add(this.mousePoint);

    // const imgWidth = 4000;
    // const imgHeight = 4000;
    // // scale 大小
    // const scale = Math.min(clientWidth / imgWidth, clientHeight / imgHeight);
    // this.stage.scale({ x: scale, y: scale });
    this.events = {
      keyboardHandler: (e) => {
        this.keyboardHandler(e);
      },
    };

    this.setBackground(this.option.url);
    this.initEvents();
  }

  async setBackground(url) {
    const { container } = this.option;
    const { clientWidth, clientHeight } = container;
    const p = new Promise((resolve, reject) => {
      if (!url) return;
      if (this.background) {
        const imageObj = new Image();
        imageObj.onload = () => {
          this.background.width(imageObj.width);
          this.background.height(imageObj.height);
          this.background.image(imageObj);
          // scale 大小
          const scale = Math.min(clientWidth / imageObj.width, clientHeight / imageObj.height);
          this.stage.scale({ x: scale, y: scale });
          let x = 0;
          x = (clientWidth - imageObj.width * scale) / 2;
          this.stage.x(x);
          this.bgLayer.draw();
          resolve();
        };
        imageObj.src = url;
        return;
      }
      this.background = new Konva.Image({
        draggable: false,
      });
      const imageObj = new Image();
      imageObj.onload = () => {
        console.log(imageObj.width);
        console.log(imageObj.height);
        this.background.width(imageObj.width);
        this.background.height(imageObj.height);
        // scale 大小
        const scale = Math.min(clientWidth / imageObj.width, clientHeight / imageObj.height);
        this.stage.scale({ x: scale, y: scale });
        let x = 0;
        x = (clientWidth - imageObj.width * scale) / 2;
        this.stage.x(x);
        this.background.image(imageObj);
        this.bgLayer.draw();
        resolve();
      };
      imageObj.src = url;
      this.bgLayer.add(this.background);
    });
    return p;
  }

  initStage() {

  }

  // 计算画布的当前坐标和缩放值
  setGraphicPosition(e) {
    const { stage } = this;
    const scaleBy = 1.05;

    e.evt.preventDefault();
    const oldScale = stage.scaleX();
    const pointer = stage.getPointerPosition();

    const mousePointTo = {
      x: (pointer.x - stage.x()) / oldScale,
      y: (pointer.y - stage.y()) / oldScale,
    };

    const newScale =
      e.evt.deltaY < 0 ? oldScale * scaleBy : oldScale / scaleBy;

    this.graphicPosition = {
      x: pointer.x - mousePointTo.x * newScale,
      y: pointer.y - mousePointTo.y * newScale,
    };
    this.graphicScale = newScale;
    stage.scale({ x: this.graphicScale, y: this.graphicScale });
    stage.position(this.graphicPosition);
    stage.batchDraw();
  }

  setCenter(x, y) {

  }

  initEvents() {
    const { stage } = this;
    // 舞台滚动放大缩小
    stage.on('wheel', (e) => {
      this.setGraphicPosition(e);
    });

    stage.on('dragmove', (e) => {
    });

    stage.on('dragend', (e) => {
    });

    // 鼠标移动
    stage.on('mousemove', (e) => {
      const { x, y } = this.getWorldPosition(e);

      if (this.mousePoint) {
        this.mousePoint.x(x);
        this.mousePoint.y(y);
        this.areaLayer.batchDraw();
      }
      if (this.state === STATE.ADD) {
        if (this.prevPoint) {
          if (!this.prevLine) {
            this.prevLine = new Konva.Line({
              stroke: 'blue',
              strokeWidth: 4,
              closed: false,
            });
            this.areaLayer.add(this.prevLine);
            // this.prevLine.points([this.prevPoint.x, this.prevPoint.y, x, y]);
          }
          const res = [];
          this.curPoints.forEach((p) => {
            res.push(p.x, p.y);
          });
          const p0 = this.curPoints[0]; // 起点
          const dx = Math.abs(p0.x - x);
          const dy = Math.abs(p0.y - y);
          const dis = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
          if (dis <= 10) {
            if (this.curPoints && this.curPoints.length >= 3) {
              // x = p0.x
              // y = p0.y
              this.prevLine.points([...res, p0.x, p0.y]);
            }
          } else {
            this.prevLine.points([...res, x, y]);
          }
          this.areaLayer.batchDraw();
        }
      }
    });

    stage.on('mouseup', (e) => {
    });
    // 双击
    stage.on('dblclick', (e) => {
      if (this.state === STATE.EDIT) {
        if (e.target.id()) {
          this.editLayer.destroyChildren();
          console.log('双击编辑');
          // 编辑点位渲染
          const ele = this.graphicList.find(i => i.id === e.target.id());
          const points = [];
          if (ele && !ele.data) {
            return;
          }
          ele.data.forEach((i) => {
            points.push(this.pointDict[i]);
          });
          points.forEach((i) => {
            const point = new Konva.Circle({
              pid: i.id,
              id: uuid(),
              x: i.x + ele.property.x,
              y: i.y + ele.property.y,
              radius: 8,
              fill: 'red',
              draggable: true,
            });
            // 点位拖拽
            point.on('dragmove', (e) => {
              const { x, y } = this.getWorldPosition(e);
              this.pointDict[e.target.attrs.pid].x = x - ele.property.x;
              this.pointDict[e.target.attrs.pid].y = y - ele.property.y;
              ele.updatePoints();
              this.areaLayer.batchDraw();
            });
            point.on('mouseover', (e) => {
              point.fill('blue');
              point.draw();
            });
            point.on('mouseout', (e) => {
              point.fill('red');
              point.draw();
            });
            this.editLayer.add(point);
            this.editLayer.draw();
          });
        }
      }
    });

    // 点击
    stage.on('click', (e) => {
      // 如果点击的是空位
      if (!e.target.id() || e.target.id() === -1) {
        this.option.listeners.areaClickHandler(
          null,
          'area',
          null,
        );
        this.changeTransformNodes(null);
        this.editLayer.destroyChildren();
        this.editLayer.draw();
      }
      // 左击
      if (e.evt.button === 0) {
      }
      if (this.state === STATE.ADD) {
        // 左击
        if (e.evt.button === 0) {
          this.addPoint();
          if (this.curPoints && this.curPoints.length >= 3) {
            const p0 = this.curPoints[0]; // 起点
            const pLast = this.curPoints[this.curPoints.length - 1]; // 终点
            const dx = Math.abs(p0.x - pLast.x);
            const dy = Math.abs(p0.y - pLast.y);
            const dis = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
            if (dis <= 10) {
              this.curPoints[this.curPoints.length - 1].x = p0.x;
              this.curPoints[this.curPoints.length - 1].y = p0.y;
              const data = _.cloneDeep(this.curPoints.map(c => c.id));
              data.pop();
              const property = { remarks: '', retain: true, x: 0, y: 0 };
              // 添加区域
              const newArea = this.addArea({ data, property });
              this.option.listeners.areaClickHandler(
                newArea.toObject(),
                'area',
                newArea.ele.id,
              );
              delete this.pointDict[pLast.id];
              this.prevPoint = null;
              this.curPoints = null;
              if (this.prevLine) this.prevLine.destroy();
              this.prevLine = null;
              this.areaLayer.batchDraw();
              this.changeStageState('edit');
            }
          }
        }
        // 右击
        if (e.evt.button === 2) {
          this.curPoints.forEach((e) => {
            delete this.pointDict[e.id];
          });
          this.prevPoint = null;
          this.curPoints = null;
          if (this.prevLine) this.prevLine.destroy();
          this.prevLine = null;
          this.areaLayer.batchDraw();
          this.changeStageState('edit');
        }
      }
    });

    // 右键
    stage.on('contentContextmenu', (e) => {
      e.evt.preventDefault();
      e.evt.stopPropagation();
    });

    // 键盘
    window.addEventListener('keydown', this.events.keyboardHandler);
  }

  // 键盘事件
  keyboardHandler(e) {
    this.key = e.key;
  }

  //  添加点位
  addPoint(e) {
    this.changeTransformNodes(null);

    const x = this.mousePoint.x();
    const y = this.mousePoint.y();

    const point = new Point(
      null,
      x,
      y,
    );
    this.pointDict[point.id] = point;
    if (!this.curPoints) {
      this.curPoints = [];
    }
    this.curPoints.push(point);
    this.prevPoint = point;
    this.render();
  }

  // 世界坐标系
  getWorldPosition(e) {
    const { top, left } = this.option.container.getBoundingClientRect();
    const scale = this.stage.scaleX();
    const offsetX = this.stage.x();
    const offsetY = this.stage.y();
    return {
      x: (e.evt.x - offsetX - left) / scale,
      y: (e.evt.y - offsetY - top) / scale,
    };
  }

  // 元素选中
  changeTransformNodes(node) {
    if (this.prevNode && this.prevNode.graphic) {
      this.prevNode.graphic.setSelected(false);
    }
    if (!node) {
      this.tr.nodes([]);
    } else {
      this.prevNode = node;
      if (this.prevNode && this.prevNode.graphic) {
        this.prevNode.graphic.setSelected(true);
      }
      this.tr.nodes([node]);
    }
  }

  // 操作状态
  changeStageState(state) {
    if (state === this.state) return;
    console.log('changeStageState');
    if (this.prevLine) {
      this.prevLine.destroy();
    }
    if (state === STATE.EDIT) {
      this.viewLayer.removeChildren();
      this.viewLayer.batchDraw();
      this.areaLayer.show();
      this.graphicList.forEach((g) => {
        if (g.canDraggable) {
          g.ele.draggable(true);
        }
      });
      this.mousePoint.hide();
    } else {
      this.graphicList.forEach((g) => {
        if (g.canDraggable) {
          g.ele.draggable(false);
        }
      });
      this.mousePoint.show();
    }
    if (state === STATE.VIEW) {
      this.viewGraphics();
    }
    if (state === STATE.ADD) {
      this.option.listeners.areaClickHandler(
        null,
        'area',
        null,
      );
      this.changeTransformNodes(null);
    }
    this.prevLine = null;
    this.prevPoint = null;
    this.curPoints = null;
    this.state = state;
    this.editLayer.destroyChildren();
    this.editLayer.batchDraw();
    this.option.listeners.changeStageState(state);
  }

  render() {
    this.bgLayer.batchDraw();
    this.areaLayer.batchDraw();
    this.editLayer.batchDraw();
  }

  // 添加区域
  addArea(target) {
    const ele = new Area(target, this);
    this.graphicList.push(ele);
    // if (this.option.listeners.graphicChanged) {
    //   this.option.listeners.graphicChanged(ele.toObject());
    // }
    return ele;
  }

  // 区域块点击
  areaClickHandler(e) {
    if (e.evt.button === 0 && (this.state === STATE.VIEW || this.state === STATE.EDIT)) {
      this.changeTransformNodes(e.currentTarget);
      this.option.listeners.areaClickHandler(
        this.graphicList.find(i => i.id === e.currentTarget.id()).toObject(),
        'area',
        this.pointDict[e.currentTarget.id()],
      );
    }
  }

  // 加载图形
  loadGraphics(data, key) {
    if (!data) return;
    if (!data.point_dict || data.point_dict.length <= 0) return;
    Object.entries(data.point_dict).forEach((i) => {
      const point = new Point(i[1].uuid, i[1].x, i[1].y);
      this.pointDict[point.id] = point;
    });
    data.graphic_list.forEach((g) => {
      this.addArea({ data: g.graphic_data, id: g.graphic_id, property: g.property }, this);
    });
    if (!key) {
      // this.areaLayer.draw()
    }
  }

  // 预览模式
  viewGraphics() {
    this.areaLayer.hide();
    const point_dict = this.exportData().point_dict;
    const graphic_list = this.exportData().graphic_list;
    if (point_dict.length <= 0) return;
    const pointDict = {};
    Object.entries(point_dict).forEach((key) => {
      const point = new Point(key[1].uuid, key[1].x, key[1].y);
      pointDict[point.id] = point;
    });
    graphic_list.forEach((g) => {
      const points = [];
      g.graphic_data.forEach((pid) => {
        points.push(pointDict[pid].x, pointDict[pid].y);
      });
      if (g.property.retain) {
        const line = new Konva.Line({
          x: g.property.x || 0,
          y: g.property.y || 0,
          points,
          fill: 'rgba(0, 0, 255, 0.2)',
          stroke: 'blue',
          globalCompositeOperation: 'source-over',
          strokeWidth: 1,
          closed: true,
        });
        this.viewLayer.add(line);
      }
    });
    graphic_list.forEach((g) => {
      const points = [];
      g.graphic_data.forEach((pid) => {
        points.push(pointDict[pid].x, pointDict[pid].y);
      });
      if (!g.property.retain) {
        const line = new Konva.Line({
          x: g.property.x || 0,
          y: g.property.y || 0,
          points,
          fill: 'rgba(0, 0, 255, 44)',
          stroke: 'blue',
          globalCompositeOperation: 'destination-out',
          strokeWidth: 1,
          closed: true,
        });
        this.viewLayer.add(line);
      }
    });
    this.viewLayer.batchDraw();
  }

  // 更新数据
  updateGraphic(target) {
    if (!target.graphic_id) return;
    const graphic = this.graphicList.find(g => g.id === target.graphic_id);
    if (!graphic) return;
    graphic.update(target);
    this.render();
  }

  // 删除
  deleteGraphic(id) {
    const graphicList = this.graphicList.filter(g => g.id === id);
    if (!graphicList) return;
    this.editLayer.destroyChildren();
    this.editLayer.draw();
    this.changeStageState('edit');
    graphicList.forEach((g) => {
      // 删除对应字典数据
      g.data.forEach((i) => {
        delete this.pointDict[i];
      });
      g.ele.destroy();
      const gIndex = this.graphicList.findIndex(l => l.id === id);
      this.graphicList.splice(gIndex, 1);
    });
    this.changeTransformNodes(null);
    this.render();
  }

  // 数据输出
  exportData(data = {}) {
    const {
      pointDict,
      graphicList,
    } = data;
    const pointData = pointDict || this.pointDict;
    const graphicData = graphicList || this.graphicList;
    const point_dict = {};
    Object.entries(pointData).forEach((key) => {
      point_dict[key[0]] = {
        uuid: key[1].uuid,
        x: key[1].x,
        y: key[1].y,
      };
    });
    const graphic_list = [];
    graphicData.forEach((g) => {
      graphic_list.push(g.toObject());
    });
    const area = [];
    console.log(graphic_list);
    console.log(point_dict);
    graphic_list.forEach((e) => {
      const item = [];
      e.graphic_data.forEach((i) => {
        item.push({
          x: point_dict[i].x + e.property.x,
          y: point_dict[i].y + e.property.y,
        });
      });
      area.push(item);
    });
    return _.cloneDeep({
      point_dict,
      graphic_list,
      area,
      image: {
        width: this.background && this.background.width(),
        height: this.background && this.background.height(),
      },
    });
  }
}
